import { Link, useNavigate } from "react-router-dom";
import "../assets/scss/custom/_custom.scss";
import logoIcon from "../assets/img/logo-icon.png";
import landingBg from "../assets/img/landing-bg.png";
import wellinksLogo from "../assets/img/S360-logo.svg";
import spire360 from "../assets/img/Spire360-logo.png";
import { useEffect } from "react";
import { loginRequest } from "../auth-config";
import { InteractionStatus } from "@azure/msal-browser";
import Spinner from "../components/Spinner";
import useLoggedInAccount from "../auth/LoggedInAccountInfo";

const LandingPage = () => {
  const { instance, inProgress, loggedInAccount } = useLoggedInAccount();
  const clientTenantId = process.env.REACT_APP_CLIENT_TENANT_ID;
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (inProgress !== InteractionStatus.None) {
      console.log("Authentication already in progress...");
      return;
    }
    await instance.loginRedirect({
          ...loginRequest,
          prompt: 'select_account',
      });
  };

  useEffect(() => {
    if (inProgress === InteractionStatus.None && loggedInAccount) {
      const activeAccount = instance.getActiveAccount();
      if (!activeAccount || (activeAccount && activeAccount.tenantId !== clientTenantId)) {
        instance.setActiveAccount(loggedInAccount);
      }
      navigate("/home", { replace: true });
    }
  }, [loggedInAccount, inProgress, instance, navigate]);

  return (
    <>
      {inProgress === InteractionStatus.Login ||
      inProgress === InteractionStatus.Startup ? (
        <Spinner />
      ) : inProgress === InteractionStatus.None && !loggedInAccount ? (
        <main className="main">
          <div className="d-flex vh-100 landing-bg">
            <div className="d-flex align-items-center justify-content-center h-100 d-none d-md-flex flex-fill">
              <div className="text-center">
                <div>
                    <img height={100}
                    src={logoIcon}
                    alt="Wellinks Logo"
                    />
                </div>
                <h1 className="display-6 fw-bold m-0">
                  A Holistic Approach to <br /> COPD Management
                </h1>
              </div>
            </div>

            <div className="d-flex flex-column h-100 max-w-md-25 w-100 bg-white">
              <div className="text-center px-4 py-5 border-bottom">
                <img
                  src={wellinksLogo}
                  alt="Wellinks Logo"
                  className="w-15rem"
                />
              </div>
              <div className="flex-fill d-flex align-items-center justify-content-center text-center">
                <div className="p-4">
                  <h4 className="text-primary fw-bold">
                    Welcome to Spire<span className="fw-normal">360&deg;</span>
                  </h4>
                  <div className="circle-logo mb-4">
                    <img src={spire360} alt="Spire Logo" />
                  </div>
                  <a
                    href="#"
                    onClick={handleLogin}
                    className="btn btn-primary px-7 rounded-2"
                  >
                    Click here to login
                  </a>
                </div>
              </div>
              <div>
                <div className="text-muted border-top py-3 text-center">
                  Copyright &copy; 2025{" "}
                  <span className="fw-bold text-primary">Wellinks.</span> All
                  Rights Reserved.
                </div>
              </div>
            </div>
          </div>
        </main>
      ) : null}
    </>
  );
};

export default LandingPage;
